import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import { AccessibilityButton } from "@/components/AccessibilityButton";
import { ServicesHero, ServicesGrid, AdditionalServices, ServicesCTA } from "@/components/Services";
import { openGoogleCalendar } from "@/lib/utils";

export default function Servicos() {
  const handleSchedule = () => {
    openGoogleCalendar();
  };

  return (
    <>
      <div className="min-h-screen bg-white">
        <Header />
        <div className="pt-24">
        <ServicesHero />
        <ServicesGrid onSchedule={handleSchedule} />
        <div className="container mx-auto px-6 pb-16">
          <AdditionalServices onSchedule={handleSchedule} />
        </div>
        <ServicesCTA />
        </div>
        <Footer />
        <FloatingWhatsApp />
        <AccessibilityButton />
      </div>
    </>
  );
}
